"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioWrapper = exports.RadioText = exports.RadioCircleChild = exports.RadioCircle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var circleColor = function circleColor(_ref) {
  var selected = _ref.selected,
    disabled = _ref.disabled;
  if (disabled) {
    return selected ? '--color-neutral-100' : '--color-neutral-80';
  }
  return selected ? '--color-secondary-120' : '--color-neutral-100';
};
var textColor = function textColor(_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? '--color-neutral-80' : '--color-neutral-120';
};
var RadioWrapper = exports.RadioWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  flex-flow: row;\n  margin: var(--spacing-1);\n"])));
var RadioCircle = exports.RadioCircle = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(", ");\n  border-radius: 100px;\n  box-sizing: border-box;\n  height: 24px;\n  margin: 0 var(--spacing-2) 0 0;\n  padding: var(--spacing-1);\n  width: 24px;\n"])), function (props) {
  return circleColor(props);
});
var RadioCircleChild = exports.RadioCircleChild = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-radius: 100px;\n  height: 12px;\n  width: 12px;\n  background-color: var(", ");\n  flex-shrink: 0;\n"])), function (props) {
  return circleColor(props);
});
var RadioText = exports.RadioText = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: var(", ");\n  font-family: var(--font-family);\n  font-size: 16px;\n  line-height: 24px;\n  flex: 1;\n"])), function (props) {
  return textColor(props);
});